import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles, Clock } from 'lucide-react';

export default function FinalCTA() {
  return (
    <section className="py-20 bg-gradient-to-br from-primary/5 via-secondary/5 to-primary/10">
      <div className="mx-auto max-w-4xl px-4 md:px-6 text-center">
        
        <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium mb-6">
          <Sparkles className="w-4 h-4" />
          Ready to accelerate your career?
        </div>

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
          Your career breakthrough starts today
        </h2>
        
        <p className="text-lg md:text-xl text-muted-foreground mb-2 max-w-2xl mx-auto leading-relaxed">
          Join thousands of professionals who've already advanced their careers with SkillBinder's AI-powered guidance and industry-specific insights.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-2">
          <Link 
            to="/authentication" 
            className="group w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-xl bg-primary text-primary-foreground px-8 py-1 hover:bg-primary/90 transition-all duration-200 font-semibold text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
          >
            Start Your Journey Free
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>
          
          <Link 
            to="/subscription-management" 
            className="w-full sm:w-auto inline-flex items-center justify-center rounded-xl bg-card text-primary px-8 py-1 border-2 border-primary hover:bg-primary/5 transition-all duration-200 font-medium text-lg"
          >
            View Premium Plans
          </Link>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 text-sm text-muted-foreground">
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4" />
            <span>5-minute setup</span>
          </div>
          <div className="w-px h-4 bg-border"></div>
          <span>✓ No credit card required</span>
          <div className="w-px h-4 bg-border"></div>
          <span>✓ Cancel anytime</span>
          <div className="w-px h-4 bg-border"></div>
          <span>✓ 10,000+ satisfied users</span>
        </div>

        <div className="mt-12 p-6 bg-card rounded-2xl border border-border">
          <div className="flex items-center justify-center gap-4 text-sm">
            <div className="flex items-center gap-2 text-green-600">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              <span className="font-medium">Live</span>
            </div>
            <span className="text-muted-foreground">
              <strong className="text-foreground">127 professionals</strong> started their career plans in the last 24 hours
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}